<template>
  <ReviewsSection />
</template>

<script>
import ReviewsSection from '../components/sections/ReviewsSection.vue'

export default {
  name: 'ReviewsPage',
  components: {
    ReviewsSection
  }
}
</script>
